var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "main-content flex-1 bg-gray-100 mt-20 md:mt-20 pb-50 md:pb-5 overflow-y-scroll"
    },
    [
      _c("div", { staticClass: "flex flex-wrap" }, [
        _c("div", { staticClass: "w-full p-3" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "overflow-y-auto" },
            [
              _c(
                "div",
                { staticStyle: { "margin-bottom": "10px" } },
                [
                  _c(
                    "el-row",
                    { staticClass: "px-5 py-2" },
                    [
                      _c(
                        "el-col",
                        { staticClass: "flex flex-row", attrs: { span: 18 } },
                        [
                          _c(
                            "el-row",
                            { staticClass: "px-5 py-2 w-full" },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "flex flex-row w-50",
                                  attrs: { span: 4 }
                                },
                                [_vm._v("Filter Date")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticClass: "flex flex-row mr-1 w-full",
                                  attrs: { span: 18 }
                                },
                                [
                                  _c("date-range-picker", {
                                    ref: "picker",
                                    attrs: {
                                      timePicker: false,
                                      showDropdowns: false,
                                      "max-date": _vm.maxDate,
                                      opens: "right",
                                      "auto-apply": true
                                    },
                                    on: { update: _vm.onChangeDate },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "input",
                                        fn: function(picker) {
                                          return [
                                            _vm._v(
                                              "\n                      From: " +
                                                _vm._s(
                                                  _vm.moment(picker.startDate)
                                                ) +
                                                " - To: " +
                                                _vm._s(
                                                  _vm.moment(picker.endDate)
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        }
                                      }
                                    ]),
                                    model: {
                                      value: _vm.dateRange,
                                      callback: function($$v) {
                                        _vm.dateRange = $$v
                                      },
                                      expression: "dateRange"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "data-tables-server",
                {
                  ref: "tableTransaction",
                  attrs: {
                    data: _vm.data,
                    total: _vm.total,
                    "pagination-props": {
                      background: true,
                      pageSizes: [_vm.displayingItem]
                    }
                  },
                  on: { "query-change": _vm.onChangeTable }
                },
                _vm._l(_vm.titles, function(title) {
                  return _c("el-table-column", {
                    key: title.prop,
                    attrs: {
                      prop: title.prop,
                      label: title.label,
                      sortable: "custom"
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "bg-gray-400 border-b-2 border-gray-500 rounded-tl-lg rounded-tr-lg p-2"
      },
      [
        _c("h5", { staticClass: "font-bold uppercase text-gray-600" }, [
          _vm._v(" Content Purchase")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d8e6fe2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d8e6fe2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Transactions.vue
// module id = null
// module chunks = 